import React from "react"
import PropTypes from "prop-types"
import {
  InternalRHSCTAContainer,
  Title,
  Excerpt,
  InternalRHSCTAButton,
} from "./style"

const InternalRHSCTA = ({ title, excerpt, label, link }) => {
  return (
    <InternalRHSCTAContainer>
      <Title>{title}</Title>
      <Excerpt>{excerpt}</Excerpt>
      <InternalRHSCTAButton to={link} label={label} />
    </InternalRHSCTAContainer>
  )
}

export default InternalRHSCTA

InternalRHSCTA.defaultProps = {
  title: "Business programs & Support",
  excerpt:
    "Discover a variety of programs helping ACT-based businesses and new entrepreneurs to get started, prosper and grow.",
  label: "Read More",
  link: "/",
}

InternalRHSCTA.propTypes = {
  title: PropTypes.string,
  excerpt: PropTypes.string,
  links: PropTypes.string,
  label: PropTypes.string,
}
